import styled from 'styled-components';
import { THEME } from '../../../themes';
import { ASSETS } from '../../../assets';
import { DialogBackgroundColor } from './base-dialog';

const DIALOG_Z_INDEX = THEME.Z_INDEX.HIGH;

export const DialogContainer = styled.div<{
  widthSize: string;
  $zIndex?: number;
  $isFullScreen?: boolean
  $backgroundColor?:DialogBackgroundColor
}>`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  height: ${({ $isFullScreen }) => $isFullScreen ? '100vh' : 'fit-content'};
  //height: fit-content;
  min-height:  ${($isFullScreen) => $isFullScreen ? 'auto' : '240px'};
  width: ${({ widthSize, $isFullScreen }) => $isFullScreen ? '100vw' : widthSize};
  box-sizing: border-box;
  background-color: ${({ $backgroundColor }) => $backgroundColor === 'secondary' ? THEME.COLORS.LIGHT_GREY : THEME.COLORS.SURFACE_PRIMARY};
  z-index: ${({ $zIndex }) => $zIndex ?? DIALOG_Z_INDEX};
  display: flex;
  flex-direction: column;
  border-radius: ${({ $isFullScreen }) => $isFullScreen ? '0' : THEME.RADIUS.LOOPY};
  padding: 10px 0;
  overflow: hidden;
`;

export const Backdrop = styled.div<{
  disableFilter?: boolean;
  $zIndex?: number;
}>`
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: ${({ $zIndex }) => $zIndex ?? DIALOG_Z_INDEX - 1};
  background-color: ${THEME.COLORS_RGB.TRUE_BLACK_012};
  backdrop-filter: ${({ disableFilter }) => disableFilter ? 'unset' : 'blur(16px)'};
`;

export const CloseButtonContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  margin-top: ${THEME.SPACING.BASE};
  margin-right: ${THEME.SPACING.BASE};
  z-index: 1;
`;

export const CloseButton = styled(ASSETS.CLOSE_DIALOG_COMPONENT)`
  width: 32px;
  height: 32px;
  font-size: 0;
  border-radius: ${THEME.RADIUS.CIRCLE};
  cursor: pointer;
  transition: all 0.2s;
  z-index:2;
  :hover {
    opacity: ${THEME.OPACITY.MED};
  }
`;
